import { jsx as _jsx } from "react/jsx-runtime";
// ---Third-party imports
import React from 'react';
// ---Framework imports
import { PortalTarget, AutoPortal } from 'uix/components';
// ---Globals
export const WikiModalTarget = ()=>/*#__PURE__*/ _jsx(PortalTarget, {
        as: "div",
        id: "WikiModalPortal"
    });
export const WikiModalPortal = ({ children })=>/*#__PURE__*/ _jsx(AutoPortal, {
        target: "WikiModalPortal",
        children: children
    });
